// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/retention/public/v1/rewards_api.proto (package gdx.retention.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ClaimRewardRequest, ClaimRewardResponse, GetRewardsRequest, GetRewardsResponse } from "./rewards_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Retention rewards service service.
 *
 * @generated from service gdx.retention.public.v1.RewardsAPIService
 */
export const RewardsAPIService = {
  typeName: "gdx.retention.public.v1.RewardsAPIService",
  methods: {
    /**
     * Gets a reward promotion with stages for logged user.
     * returns NOT_FOUND if user is not legible for this promo type
     *
     * @generated from rpc gdx.retention.public.v1.RewardsAPIService.GetRewards
     */
    getRewards: {
      name: "GetRewards",
      I: GetRewardsRequest,
      O: GetRewardsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Claims rewards for user for specified promotion type and stage.
     * returns NOT_FOUND if promo type of stage id does not exists for specified user
     * returns ALREADY_EXISTS if this reward was already been claimed
     * returns FAILED_PRECONDITION if this reward is not available for user (yet or expired)
     *
     * @generated from rpc gdx.retention.public.v1.RewardsAPIService.ClaimReward
     */
    claimReward: {
      name: "ClaimReward",
      I: ClaimRewardRequest,
      O: ClaimRewardResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

